import type { FunctionComponent } from "react";
import BudgetAllocatedIllustration from "../assets/svgs/campaigns/budget-allocated.svg";
import { Slider } from "./ui/slider";
import {
	CampaignStatus,
	type ICampaign,
} from "../types/models/campaign.models.types";
import millify from "millify";
import { useUserStore } from "../store/user.store";
import { AccountType } from "../constants/account-types.constants";

interface AppProps {
	campaign: ICampaign;
	status: CampaignStatus;
	stat1?: string;
	stat2?: string;
	stat3?: string;
}

const MiniStats: FunctionComponent<AppProps> = ({
	campaign,
	status,
	stat1,
	stat2,
	stat3,
}) => {
	const { user } = useUserStore();

	switch (status) {
		case CampaignStatus.live:
			return (
				<div className="flex flex-col gap-10 rounded-lg w-full">
					{user?.accountType === AccountType.ADMIN ? (
						<div className="flex flex-col gap-3">
							<div className="flex justify-between items-center w-full">
								<span className="font-semibold text-secondary text-sm">
									Budget used
								</span>
								<span className="font-semibold text-primary text-sm">
									₹ {stat3}
								</span>
							</div>

							<Slider
								stepsVisible={false}
								thumbWidth="24"
								max={campaign.budget || 0}
								value={[campaign.metrics?.budgetUsed || 0]}
							/>
						</div>
					) : (
						<></>
					)}

					<div className="flex px-3 pb-3">
						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Current views
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat1}
							</span>
						</div>

						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Current posts
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat2}
							</span>
						</div>
					</div>
				</div>
			);

		case CampaignStatus.adminDraft:
			return (
				<div className="flex flex-col gap-4 w-full">
					{user?.accountType === AccountType.ADMIN ? (
						<div className="flex items-center gap-9 py-2 pl-2 border border-border rounded-lg">
							<BudgetAllocatedIllustration />
							<div className="flex flex-col">
								<span className="font-semibold text-secondary text-sm">
									Budget allocated
								</span>
								<span className="font-bold text-xl">
									₹ {millify(campaign.budget || 0)}
								</span>
							</div>
						</div>
					) : (
						<></>
					)}

					<div className="flex px-3 pb-3">
						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Estimated views
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat1}
							</span>
						</div>

						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Estimated posts
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat2}
							</span>
						</div>
					</div>
				</div>
			);

		case CampaignStatus.ended:
			return (
				<div className="flex flex-col gap-10 rounded-lg w-full">
					{user?.accountType === AccountType.ADMIN ? (
						<div className="flex flex-col gap-3">
							<div className="flex justify-between items-center w-full">
								<span className="font-semibold text-secondary text-sm">
									Budget used
								</span>
								<span className="font-semibold text-primary text-sm">
									₹ {stat3}
								</span>
							</div>

							<Slider
								stepsVisible={false}
								thumbWidth="24"
								max={campaign.budget || 0}
								value={[campaign.metrics?.budgetUsed || 0]}
							/>
						</div>
					) : (
						<></>
					)}
					<div className="flex px-3 pb-3">
						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Current views
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat1}
							</span>
						</div>

						<div className="flex flex-col flex-1 text-left">
							<span className="border-primarybuttonbg pl-1 border-l-2 font-semibold text-secondary text-sm">
								Current posts
							</span>
							<span className="pl-2 font-bold text-lg text-primary">
								{stat2}
							</span>
						</div>
					</div>
				</div>
			);

		default:
			return;
	}
};

export default MiniStats;
